import React from 'react';
import Biological from '../../../views/practice/biological/Biological';
import PracticeOshaHipaa from '../../../views/practice/dentalenhancements/OshaHipaa';
import PracticeDashboard from '../../../views/corp/practice/PracticeDashboard';
import { childrenDERoutes } from '../../practice/dentalenhancements/DERoutes';
import WaterlineManagement from '../../../views/practice/waterline/Waterline';
import TrainingWrapper from '../../../views/practice/training/TrainingWrapper';
import MedicalWaste from '../../../views/practice/wastemanagement/medicalwaste/MedicalWaste';
import PharmaceuticalWaste from '../../../views/practice/wastemanagement/pharmaceuticalwaste/PharmaceuticalWaste';
import AmalgamWaste from '../../../views/practice/wastemanagement/amalgamwaste/AmalgamWaste';
import BackorderedItems from '../../../views/practice/shipments/BackorderedItems';
import PendingApprovals from '../../../views/practice/shipments/pendingapprovals/PendingApprovals';
import ShipmentHistory from '../../../views/practice/shipments/shipmenthistory/ShipmentHistory';
import ShipmentsWrapper from '../../../views/practice/shipments/ShipmentsWrapper';
import UpcomingShipments from '../../../views/practice/shipments/UpcomingShipments';
import Medications from '../../../views/practice/meds-devices/medications/Medications';
import Devices from '../../../views/practice/meds-devices/devices/Devices';
import TeamMembers from '../../../views/practice/team-members/TeamMembers';
import AutoRenewals from '../../../views/practice/autorenewals/AutoRenewals';
import Tasks from '../../../views/practice/tasks/Tasks'
import { default as Dashboard } from '../../../views/practice/dashboard/Dashboard';
import Reports from '../../../views/practice/reports/Reports';
import ConfirmAutoclaveType from '../../../views/practice/biological/ConfirmAutoclaveType';

const PracticeRoutes = [
  {
    path: 'corp/practice/:customerNumber',
    element: <PracticeDashboard />,
    children: [
      {
        path: 'biological',
        element: <Biological />
      },
      {
        path: 'biological/confirm-autoclave-type',
        element: <ConfirmAutoclaveType />
      },
      {
        path: 'dashboard',
        element: <Dashboard />
      },
      {
        path: 'osha-hipaa/:year?',
        element: <PracticeOshaHipaa />,
        children: childrenDERoutes
      },
      {
        path: 'training',
        element: <TrainingWrapper />
      },
      {
        path: 'waterline-management',
        element: <WaterlineManagement />
      },
      {
        path: 'medical-waste',
        element: <MedicalWaste />
      },
      {
        path: 'pharmaceutical-waste',
        element: <PharmaceuticalWaste />
      },
      {
        path: 'amalgam-waste',
        element: <AmalgamWaste />
      },
      {
        path: 'medications',
        element: <Medications />
      },
      {
        path: 'devices',
        element: <Devices />
      },
      {
        path: 'shipments',
        element: <ShipmentsWrapper />,
        children: [
          {
            path: 'upcoming',
            element: <UpcomingShipments />
          },
          {
            path: 'pending/:kitId?',
            element: <PendingApprovals />
          },
          {
            path: 'backorders',
            element: <BackorderedItems />
          },
          {
            path: 'history',
            element: <ShipmentHistory />
          }
        ]
      },
      {
        path: 'team-members',
        element: <TeamMembers />
      },
      {
        path: 'auto-renewals',
        element: <AutoRenewals />
      },
      {
        path: 'tasks',
        element: <Tasks/>
      },
      {
        path: 'reports',
        element: <Reports/>
      }
    ]
  }
];

export default PracticeRoutes;
